import { Cubby } from "../Cubby";

export const inboundLiquidity = (cubby: Cubby) => {
  if (!cubby.hasOpenChannels) {
    return 0;
  }

  const openActiveChannels =
    cubby.channelsList?.data.filter(
      (channel) => channel.synthetic_status === "open" && channel.is_active
    ) || [];

  const totalInboundLiquidity = openActiveChannels.reduce((total, channel) => {
    const availableRemoteBalance = Math.max(
      0,
      channel.remote_balance - channel.remote_reserve
    );
    return total + availableRemoteBalance;
  }, 0);

  return Math.max(totalInboundLiquidity, 0);
};

export const inboundLiquidityOfBiggestPrivateChannel = (cubby: Cubby) => {
  if (!cubby.hasOpenChannels) {
    return 0;
  }

  const openActiveAndPrivateChannels =
    cubby.channelsList?.data.filter(
      (channel) =>
        channel.synthetic_status === "open" &&
        channel.is_active &&
        channel.is_private
    ) || [];

  const biggestPrivateChannelInboundLiquidity =
    openActiveAndPrivateChannels.reduce((maxInbound, channel) => {
      const availableRemoteBalance =
        channel.remote_balance - channel.remote_reserve;
      return Math.max(maxInbound, availableRemoteBalance);
    }, 0);

  return biggestPrivateChannelInboundLiquidity;
};

export const hasPublicChannelsWithInboundLiquidityAndAtLeastSixConfirmations = (
  cubby: Cubby
) => {
  if (!cubby.hasOpenChannels) {
    return false;
  }

  const openActiveAndPublicChannels =
    cubby.channelsList?.data.filter(
      (channel) =>
        channel.synthetic_status === "open" &&
        channel.is_active &&
        !channel.is_private
    ) || [];

  const hasPublicChannelsWithInboundLiquidityAndAtLeastSixConfirmations =
    openActiveAndPublicChannels.some(
      (channel) =>
        channel.remote_balance - channel.remote_reserve > 0 &&
        channel.confirmation_count >= 6
    );

  return hasPublicChannelsWithInboundLiquidityAndAtLeastSixConfirmations;
};

export const inboundLiquidityOfBiggestPublicChannel = (cubby: Cubby) => {
  if (!cubby.hasOpenChannels) {
    return 0;
  }

  const openActiveAndPublicChannels =
    cubby.channelsList?.data.filter(
      (channel) =>
        channel.synthetic_status === "open" &&
        channel.is_active &&
        !channel.is_private
    ) || [];

  const biggestPublicChannelInboundLiquidity =
    openActiveAndPublicChannels.reduce((maxInbound, channel) => {
      const availableRemoteBalance =
        channel.remote_balance - channel.remote_reserve;
      return Math.max(maxInbound, availableRemoteBalance);
    }, 0);

  return biggestPublicChannelInboundLiquidity;
};
